module.exports = __webpack_public_path__ + "img/Logo-12.ef9fe5e9.svg";